import { CnaComponent } from "./CnaComponent";

export function CnaScreen() {
  return (
    <>
      <CnaComponent />
    </>
  );
}
